import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'stripHtml' })

export class StripHtmlPipe implements PipeTransform {
  transform(value: string = ''): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');
    return doc.body.textContent || '';
  }
}